import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

export default function AiQuotaBadge({ refreshKey }) {
  const { user } = useAuth();
  const [q, setQ] = useState(null);

  useEffect(() => {
    if (!user) {
      setQ(null);
      return;
    }
    api.get("/ai/quota").then((r) => setQ(r.data)).catch(() => setQ(null));
  }, [user, refreshKey]);

  if (!user || !q) return null;
  const low = q.remaining <= 5;
  return (
    <span
      data-testid="ai-quota-badge"
      title={`You've used ${q.used} of ${q.limit} AI generations today`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-num font-semibold ${
        low ? "bg-red-600/10 text-red-600" : "bg-secondary text-muted-foreground"
      }`}
    >
      <Sparkles className="w-3 h-3" /> {q.remaining}/{q.limit} AI credits left today
    </span>
  );
}
